import { Link } from 'react-router-dom';

const safetyTips = [
  {
    icon: 'ri-chat-heart-line',
    title: '事前充分沟通',
    desc: '明确双方边界、设定安全词、了解身体状况，是每次活动开始前的必修课。',
  },
  {
    icon: 'ri-scissors-cut-line',
    title: '随身携带安全剪',
    desc: 'EMT急救剪刀是捆绑活动中不可或缺的安全装备，能在紧急情况下迅速切断绳索。',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '持续监测身体状态',
    desc: '定期检查被缚者的血液循环、神经反应和情绪状态，任何异常都应立即停止。',
  },
  {
    icon: 'ri-mental-health-line',
    title: '重视事后关怀',
    desc: '活动结束后的情绪安抚与身体恢复同样重要，是建立长期信任关系的关键环节。',
  },
];

export default function SafetyHighlight() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            安全核心：SSC原则
          </h2>
          <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
            所有捆绑调教活动都应遵循<strong>安全（Safe）、理性（Sane）、自愿（Consensual）</strong>的SSC原则。以下四点是你需要时刻牢记的安全核心。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {safetyTips.map((tip, index) => (
            <div key={index} className="bg-background-100 rounded-xl p-6 border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 mb-4">
                <i className={`${tip.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{tip.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{tip.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/safety"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            查看全部安全指南
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}